import {MDCSnackbar} from '@material/snackbar';
const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
import {
  plusCartItem,
  minusCartItem,
  cartDeleteItem
} from './cartList';

const headerCart = document.querySelector('.header__cart-dropdown')
const cartTrigger = document.querySelector('.header__top__icons__cart a');
const cartDropdown = document.querySelector('.cart-dropdown');
const dropdownOverlay = document.querySelector('.cart-dropdown__overlay');
const closeBtn = document.querySelector('.cart-dropdown__header button');

if (cartTrigger || dropdownOverlay || closeBtn) {
  const cartItems = document.querySelector('.cart-dropdown__wrapper');
  cartTrigger.addEventListener('click', (e) => {
    e.preventDefault()
    //dropdownOverlay.style.visibility = 'visible'
    //dropdownOverlay.style.opacity = '0.8'
    //cartDropdown.classList.add('cart-dropdown--active')
    LoadCartItems();
    openDropdownCart()
  })

  dropdownOverlay.addEventListener('click', (e) => {
    e.preventDefault()
    dropdownOverlay.style.visibility = ''
    dropdownOverlay.style.opacity = ''
    cartDropdown.style.transform = ''
    cartDropdown.classList.remove('cart-dropdown--active')
    cartItems.innerHTML = '';
  })

  closeBtn.addEventListener('click', (e) => {
    e.preventDefault()
    dropdownOverlay.style.visibility = ''
    dropdownOverlay.style.opacity = ''
    cartDropdown.style.transform = ''
    cartDropdown.classList.remove('cart-dropdown--active')
    cartItems.innerHTML = '';
  })

}

function assignCartButtons() {
  const buttons = document.querySelectorAll('.cartitem-button');
  buttons.forEach(b => {
    b.addEventListener('click', function() {
      const pid = b.dataset.pid
      const ctl = b.dataset.ctl
      if (ctl === "DeleteCartItem") {
        cartDeleteItem({ pid: pid })
      }
      if (ctl === "PlusCartItem") {
        plusCartItem({ pid: pid })
      }
      if (ctl === "MinusCartItem") {
        minusCartItem({ pid: pid })
      }
    })
  })
}


window.openDropdownCart = () => {
  headerCart.style.visibility = 'visible'
  dropdownOverlay.style.visibility = 'visible'
  dropdownOverlay.style.opacity = '0.8'
  cartDropdown.classList.add('cart-dropdown--active')
}

window.LoadCartItems = () => {
  fetch('/cart-items', {
    method: 'GET',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      const cartItems = document.querySelector('.cart-dropdown__wrapper');
      const cartTotalQuantity = document.querySelector('#cartTotalQuantity');
      const cartTotalPrice = document.querySelector('#cartTotalPrice');
      const cartGratisShipment = document.querySelector('#cartGratisShipment');
      const cartGratisShipmentMessage = document.querySelector('#cartGratisShipmentMessage');
      cartItems.innerHTML = v.html;
      cartTotalQuantity.innerHTML = v.quantity;
      cartTotalPrice.innerHTML = v.total;
      cartGratisShipment.innerHTML = v.shipment_gratis;
      cartGratisShipmentMessage.innerHTML = v.shipment_gratis_message;
      if (v.result) {
        assignCartButtons();
      }
    })
  })
}
